import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {z} from 'zod';
import dedent from 'dedent';
import {elementIdSchema} from '../../schemas';

const toolName = 'set-form-input-name' as const;

const argumentZod = z.object({
  elementId: elementIdSchema.describe(
    'The ID of the form input element to set the name attribute on. Must be one of: FormCheckboxInput, FormFileUploadWrapper, FormRadioInput, FormSelect, FormTextarea, or FormTextInput.'
  ),
  name: z
    .string()
    .describe(
      'The name attribute value for the form input. This identifies the input field when form data is submitted. Should be descriptive and unique within the form (e.g., "email", "firstName", "phoneNumber").'
    ),
});

export const setFormInputNameTool = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Set form input name',
  llmTool: {
    name: toolName,
    description: dedent`
      Set the name attribute of a form input element. The name attribute is crucial
      for form processing as it identifies the input field when data is submitted
      to the server. Each input in a form should have a unique, descriptive name
      that corresponds to the expected data field. Works with form input types:
      FormCheckboxInput, FormFileUploadWrapper, FormRadioInput, FormSelect, FormTextarea,
      and FormTextInput. Returns null when the name is successfully set. Essential
      for proper form data handling and server-side processing.`,
    inputSchema: argumentZod,
  },
  type: 'designer',
  confirmBeforeExecuting: true, // Modifies form data processing, requires confirmation
  timeout: 30000, // 30 seconds for setting input name
});
